import React, { useState } from "react";
import { Col, Row, Table, Card, CardBody } from "reactstrap";
import moment from "moment";
import { useQuery } from "@apollo/client";
import imageUrl from "@/utils/api/imageUrl";
import { GET_USER_BY_USERID } from "../../../../GraphQL/Queries";
import Loader from "./Loader";
import SubmitLoading from "@/utils/HelperComponent/SubmitLoading";

const UserDetailsPage = ({ match, history }) => {
  const userId = match?.params?.id;
  const { data, loading } = useQuery(GET_USER_BY_USERID, {
    variables: { id: Number(userId) },
    skip: !Number(userId),
  });

  const user = data?.getUserByUserid;
  const documents = user?.documents || [];
  const departmentsName = user?.departments?.map((d) => d.name);

  const renderDocument = (fileName) => {
    const ext = fileName.split(".").pop().toLowerCase();
    const url = `${imageUrl}/documents/${fileName}`;

    if (["jpg", "jpeg", "png"].includes(ext)) {
      return (
        <img
          src={url}
          alt={fileName}
          style={{
            width: "100%",
            height: "250px",
            // objectFit: "cover",
            borderRadius: "10px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          }}
        />
      );
    } else if (ext === "pdf") {
      return (
        <div
          onClick={() => window.open(url, "_blank")}
          style={{ cursor: "pointer", borderRadius: 10 }}
        >
          <embed
            src={url}
            type="application/pdf"
            width="100%"
            height="250px"
            style={{ borderRadius: 10 }}
          />
        </div>
      );
    } else {
      return <span className="text-muted">Unsupported format</span>;
    }
  };

  if (loading)
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <SubmitLoading color="black" />
      </div>
    );

  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h2 className="fw-bold">Profile</h2>
        {/* <h2 className="fw-bold">👤Profile</h2> */}
        <button
          className="btn btn-outline-danger btn-sm"
          onClick={() => history.goBack()}
        >
          Back
        </button>
      </div>

      <Card className=" shadow-sm">
        <CardBody>
          <Row>
            {/* Profile Overview */}
            <Col md={4} className="">
              <div className="d-flex flex-column align-items-center">
                <img
                  src={`${imageUrl}/users/${
                    user?.images ||
                    "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png"
                  }`}
                  // src={
                  //   user?.images ||
                  //   "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png"
                  // }
                  alt="Profile"
                  onError={(e) => {
                    e.target.src =
                      "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png";
                  }}
                  style={{
                    width: "150px",
                    height: "150px",
                    objectFit: "cover",
                    borderRadius: "50%",
                    border: "3px solid #f0f0f0",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                  }}
                />

                <h5 className="mt-3 fw-bold mb-1 d-flex justify-content-center align-items-center gap-2">
                  {user?.name}
                  {user?.isActive ? (
                    <span className="badge bg-success d-inline-flex align-items-center m-1 text-white gap-1">
                      <i className="bi bi-check-circle-fill"></i> Active
                    </span>
                  ) : (
                    <span className="badge bg-danger d-inline-flex align-items-center m-1 text-white gap-1">
                      <i className="bi bi-x-circle-fill"></i> Inactive
                    </span>
                  )}
                </h5>

                <div className="text-muted mb-2">
                  {user?.additionalInfo?.designationInfo?.name}
                  <br />
                  {departmentsName?.join(", ")}
                </div>

                <div className="mt-3 text-center">
                  <p className="fw-semibold mb-1">Roles</p>
                  <ul className="list-unstyled">
                    {user?.role?.map((r, i) => (
                      <li key={i} className="text-muted ">
                        {r.role_name}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              {/* <img
                src={
                  user?.images ||
                  "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png"
                }
                alt="Profile"
                onError={(e) => {
                  e.target.src =
                    "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png";
                }}
                style={{
                  width: "150px",
                  height: "150px",
                  //   objectFit: "cover",
                  borderRadius: "50%",
                  border: "3px solid #f0f0f0",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                }}
              />
              <h5 className="mt-3 fw-bold mb-1 d-flex align-items-center gap-2">
                {user?.name}
                {""}
                {user?.isActive ? (
                  <span className="badge bg-success d-inline-flex align-items-center text-white m-1 gap-1">
                    <i className="bi bi-check-circle-fill"></i> Active
                  </span>
                ) : (
                  <span className="badge bg-danger d-inline-flex align-items-center m-1 gap-1">
                    <i className="bi bi-x-circle-fill text-white"></i> Inactive
                  </span>
                )}
              </h5>

              <div className="text-muted  mb-2">
                {user?.additionalInfo?.designationInfo?.name}
                <br />
                {departmentsName?.join(", ")}
              </div>

              <div className="mt-3 text-start">
                <p className="fw-semibold mb-1">Roles</p>
                <ul className="ps-3 mb-0">
                  {user?.role?.map((r, i) => (
                    <li key={i} className="text-muted ">
                      {r.role_name}
                    </li>
                  ))}
                </ul>
              </div> */}
              <section className="mt-4">
                <h5 className="fw-bold border-bottom pb-2 mb-3 d-flex align-items-center gap-2">
                  <i className="bi bi-clipboard-check text-primary"></i> Leave
                  Information
                </h5>

                <div className="card shadow-sm border-0">
                  <div className="card-body p-3">
                    <Table
                      striped
                      bordered
                      hover
                      responsive
                      size="sm"
                      className="mb-0"
                    >
                      <tbody>
                        <tr>
                          <td>Casual</td>
                          <td>
                            <span className="badge bg-light text-dark">
                              {data?.getUserByUserid?.additionalInfo?.casual ??
                                "-"}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>Sick</td>
                          <td>
                            <span className="badge bg-light text-dark">
                              {data?.getUserByUserid?.additionalInfo?.sick ??
                                "-"}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>Annual</td>
                          <td>
                            <span className="badge bg-light text-dark">
                              {data?.getUserByUserid?.additionalInfo?.anual ??
                                "-"}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>Reimburse</td>
                          <td>
                            <span className="badge bg-light text-dark">
                              {data?.getUserByUserid?.additionalInfo
                                ?.reimburse ?? "-"}
                            </span>
                          </td>
                        </tr>

                        {data?.getUserByUserid?.gender === "Female" && (
                          <>
                            <tr>
                              <td>Maternity</td>
                              <td>
                                <span className="badge bg-light text-dark">
                                  {data?.getUserByUserid?.additionalInfo
                                    ?.maternity ?? "-"}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td>Menstrual</td>
                              <td>
                                <span className="badge bg-light text-dark">
                                  {data?.getUserByUserid?.additionalInfo
                                    ?.menstrual ?? "-"}
                                </span>
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </section>
              <section className="mt-4">
                <h5 className="fw-bold border-bottom pb-2">
                  📋 KPI Informations
                </h5>

                <Table borderless size="sm" responsive className="mb-0">
                  <tbody></tbody>
                </Table>
              </section>
            </Col>

            {/* Details */}
            <Col md={8}>
              <section className="mb-4">
                <h5 className="fw-bold border-bottom pb-2">📋 Basic Info</h5>
                <Table borderless size="sm" responsive className="mb-0">
                  <tbody>
                    <tr>
                      <td>Name</td>
                      <td>{user?.name}</td>
                    </tr>
                    <tr>
                      <td>Username</td>
                      <td>{user?.username}</td>
                    </tr>
                    <tr>
                      <td>Gender</td>
                      <td>{user?.gender}</td>
                    </tr>
                    <tr>
                      <td>Phone</td>
                      <td>{user?.phone}</td>
                    </tr>
                    <tr>
                      <td>Email</td>
                      <td>{user?.email}</td>
                    </tr>
                    <tr>
                      <td>RFID</td>
                      <td>{user?.additionalInfo?.rfid}</td>
                    </tr>
                  </tbody>
                </Table>
              </section>

              <section className="mb-4">
                <h5 className="fw-bold border-bottom pb-2">📍 Address</h5>
                <Table borderless size="sm" responsive className="mb-0">
                  <tbody>
                    <tr>
                      <td>Division</td>
                      <td>{user?.divisionInfo?.name}</td>
                    </tr>
                    <tr>
                      <td>District</td>
                      <td>{user?.districtInfo?.name}</td>
                    </tr>
                    <tr>
                      <td>Upazilla</td>
                      <td>{user?.upazillaInfo?.name}</td>
                    </tr>
                    <tr>
                      <td>Union</td>
                      <td>{user?.unionInfo?.name}</td>
                    </tr>
                    <tr>
                      <td>Village</td>
                      <td>{user?.village}</td>
                    </tr>
                  </tbody>
                </Table>
              </section>

              <section>
                <h5 className="fw-bold border-bottom pb-2">💼 Employment</h5>
                <Table borderless size="sm" responsive className="mb-0">
                  <tbody>
                    <tr>
                      <td>Company</td>
                      <td>
                        {
                          user?.companyCollaborationInfo?.[0]
                            ?.companyCollaborationCompanyInfo?.name
                        }
                      </td>
                    </tr>
                    <tr>
                      <td>Office ID</td>
                      <td>{user?.additionalInfo?.office_id}</td>
                    </tr>
                    <tr>
                      <td>Joining Date</td>
                      <td>
                        {moment(user?.additionalInfo?.joining_date).format(
                          "DD-MM-YYYY"
                        )}{" "}
                        (
                        {moment(user?.additionalInfo?.joining_date).fromNow(
                          "yy"
                        )}
                        )
                      </td>
                    </tr>
                    <tr>
                      <td>Job Type</td>
                      <td>{user?.jobType}</td>
                    </tr>
                    <tr>
                      <td>Description</td>
                      <td
                        dangerouslySetInnerHTML={{
                          __html: user?.additionalInfo?.description,
                        }}
                      />
                    </tr>
                    <tr>
                      <td>Status</td>
                      <td>{user?.isActive ? "Active" : "Inactive"}</td>
                    </tr>
                    <tr>
                      <td>Classification</td>
                      <td>{user?.EmployeeClassification}</td>
                    </tr>
                    <tr>
                      <td>Working Time</td>
                      <td>{user?.workingTime} Hours</td>
                    </tr>
                    <tr>
                      <td>Qualification</td>
                      <td>{user?.qualification}</td>
                    </tr>
                  </tbody>
                </Table>
              </section>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {/* Documents */}
      <Card className="shadow-sm">
        <CardBody>
          <h5 className="fw-bold mb-3">📎 Employee Documents</h5>
          <Row>
            {documents.length > 0 ? (
              documents.map((doc, idx) => (
                <Col md={4} className="mb-3" key={idx}>
                  {renderDocument(doc)}
                </Col>
              ))
            ) : (
              <Col>
                <p className="text-muted">No documents available.</p>
              </Col>
            )}
          </Row>
        </CardBody>
      </Card>
    </div>
  );
};

export default UserDetailsPage;
